import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../sdk";

export default function usePickUp() {
  const { hotelId } = useParams();
  const { authFetch } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [fromTimeOption, setFromTimeOption] = useState([]);
  const [toTimeOption, setToTimeOption] = useState([]);
  const [marketSegmentsOptions, setMarketSegmentsOptions] = useState([]);

  const fetchFileByDate = useCallback(
    async (date, setOption) => {
      try {
        const { get } = await authFetch({
          path: `/hotel/${hotelId}/budget-bookings/file/${date}`,
        });
        const { data } = await get();
        setOption(data || []);
      } catch (error) {
        setOption([]);
        throw error;
      }
    },
    [authFetch, hotelId]
  );

  const getFileByFromDate = useCallback(
    async (date) => {
      setIsLoading(true);
      try {
        await fetchFileByDate(date, setFromTimeOption);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchFileByDate]
  );

  const getFileByToDate = useCallback(
    async (date) => {
      setIsLoading(true);
      try {
        await fetchFileByDate(date, setToTimeOption);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchFileByDate]
  );

    const marketSegements = useCallback(async () => {
    setIsLoading(true);
    try {
      const { get } = await authFetch({
        path: `/hotel/${hotelId}/market-segments`,
      });
      const { data } = await get();
      setMarketSegmentsOptions(data || []);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [authFetch, hotelId])

  const getPickUpData = useCallback(
    async (fromFileId, toFileId, segmentId, date) => {
      setIsLoading(true);
      try {
        const { get } = await authFetch({
          path: `/hotel/${hotelId}/budget-pickup?fromFileId=${fromFileId}&toFileId=${toFileId}&date=${date}&segmentId=${segmentId}`,
        });
        const { data } = await get();
        setIsLoading(false);
        return data;
      } catch (err) {
        console.error(err);
        setIsLoading(false);
        throw err;
      }
    },
    [authFetch, hotelId]
  );

  return {
    getFileByFromDate,
    fromTimeOption,
    getFileByToDate,
    toTimeOption,
    isLoading,
    marketSegements,
    marketSegmentsOptions,
    getPickUpData,
  };
}
